import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './Projects.css';
import HighlightedTitle from '../components/HighlightedTitle';
import ProjectPage from '../components/ProjectPage';

function Animation() {
  const [imageLoaded, setImageLoaded] = useState(
    new Array(5).fill(false) // Initialize an array for 5 projects, all set to false (not loaded)
  );
  const [selectedProject, setSelectedProject] = useState(null);

  const projects = [
    {
      title: 'Toy Plane',
      date: '2025',
      summary: 'An animated short about childhood dreams.',
      images: [{ type: 'image', url: '/project_images/toy-plane.png' }],
      placeholder: '/project_images/toy-plane.png', // Fixed missing leading slash
    },
    {
      title: 'While We’ve Still Got Feet',
      date: '2024',
      summary: 'End credits animation for the Award Winning Short Film about innocence and loss.',
      images: [{ type: 'image', url: '/project_images/while-weve-still-got-feet-main.png'}, {type: "video", url: "https://www.youtube.com/watch?v=5wP6i1Az0wg"} ],
      placeholder: '/project_images/while-weve-still-got-feet-main.png',
      awards: [
        'Finalist Films Infest NYCIFIF 2024',
        'Official Selection Cannes Indie Shorts Award 2024',
        'Official Selection New York International Film Awards 2024',
        'Official Selection Indie Short Fest 2024',
      ],
    },
    {
      title: 'And They Danced',
      date: '2024',
      summary: 'A vibrant animated piece capturing the joy of dance.',
      images: [
        { type: 'image', url: '/project_images/and-they-danced.png' },
        { type: 'video', url: 'https://www.youtube.com/watch?v=QajT2onJ4G8' },
      ],
      placeholder: '/project_images/and-they-danced.png',
    },
    {
      title: 'Snowman',
      date: '2023',
      summary: 'A heartwarming story of a snowman’s journey.',
      images: [
        { type: 'image', url: '/project_images/snowman.png' },
        { type: 'video', url: 'https://www.youtube.com/watch?v=74ii7axDhro' },
      ],
      placeholder: '/project_images/snowman.png',
    },
    // {
    //   title: 'Huneebee',
    //   date: '2022',
    //   summary: 'An animated tale about a honeybee’s adventure.',
    //   images: [{ type: 'image', url: '/project_images/huneebee.png' }],
    //   placeholder: '/project_images/huneebee-placeholder.png',
    // },
  ];

  const handleImageLoad = (index) => {
    setImageLoaded((prev) => {
      const newLoadedState = [...prev];
      newLoadedState[index] = true; // Mark image as loaded
      return newLoadedState;
    });
  };

  return (
    <AnimatePresence mode="wait">
      {selectedProject ? (
        <motion.div
          key="projectPage"
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: -50 }}
          transition={{ duration: 0.5 }}
        >
          <ProjectPage project={selectedProject} onBack={() => setSelectedProject(null)} />
        </motion.div>
      ) : (
        <motion.div
          key="projectList"
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: 50 }}
          transition={{ duration: 0.5 }}
        >
          <div className="projects-container">
            {projects.map((project, index) => (
              <div
                key={index}
                className={`project-item ${index % 2 === 0 ? 'left-first' : 'right-first'}`}
                onClick={() => setSelectedProject(project)}
              >
                <div className="project-image">
                  <img
                    src={imageLoaded[index] ? project.images[0].url : project.placeholder} // Access the URL of the first image
                    alt={project.title}
                    className="project-image"
                    onLoad={() => handleImageLoad(index)} // Call handleImageLoad when image loads
                    loading="lazy" // Lazy load for better performance
                  />
                </div>
                <div className="project-text">
                  <div className="project-title">
                    <HighlightedTitle text={project.title} />
                    <p>{project.date}</p>
                  </div>
                  <p className="project-summary">{project.summary}</p>
                  {/* Display awards if they exist */}
                  {project.awards && (
                    <div className="project-awards">
                      {project.awards.map((award, i) => (
                        <p key={i} className="project-award">
                          {award}
                        </p>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default Animation;